<template>
  <FocusLayout
    :title="$t('Nice to have you with us :)')"
    :subtitle="$t('Just register to join with us')"
  >
    <RegisterForm @authenticated="$router.push({ name: 'home' })" v-bind="$attrs"></RegisterForm>
  </FocusLayout>
</template>

<script>
import RegisterForm from "@c/Auth/RegisterForm";
import FocusLayout from "@/landing/layout/FocusLayout";

export default {
  components: {
    RegisterForm,
    FocusLayout,
  },
  created() {
    if (this.$store.state.auth) this.$router.push({ name: "home" });
  },
};
</script>
